import React from "react";
import { push } from "connected-react-router";
import Action from "pages/_components/Action";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { isIOS } from "react-device-detect";
import ExpirationAgendaList from "./components/ExpirationAgendaList";

const ServicePaymentsPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const options = [
        {
            text: "payments.service.supported",
            textType: "I18N",
            func: () => dispatch(push("/adheredServices/list")),
        },
        {
            text: "payments.service.recharges",
            textType: "I18N",
            func: () => dispatch(push("/Payment/refills")),
        },
    ];

    // const handleAfipPay = () => {
    //     dispatch(push("/afip/newPayment"));
    // };

    return (
        <>
            <Notification scopeToShow="servicePaymentsPage" />
            <ResponsiveHeader id="payments.service.title" showLabel>
                <DesktopButtons moreOptions={options}>
                    {/* <Button
                        className="btn btn-outline btn-block"
                        label="payments.service.afip"
                        onClick={handleAfipPay}
                    /> */}
                    <Link className="btn btn-primary btn-block small" to="/servicePayments/new">
                        <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                        <I18n id="payments.service.new" />
                    </Link>
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="payments.service.afip" to="/afip/newPayment" />
                    <Action labelKey="payments.service.new" to="/servicePayments/new" />
                    <Action labelKey="payments.service.supported" to="/adheredServices/list" />
                    <Action labelKey="payments.service.recharges" to="/Payment/refills" />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer className="service-payments">
                <ExpirationAgendaList isDesktop={isDesktop} />
            </MainContainer>
        </>
    );
};

ServicePaymentsPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ServicePaymentsPage;
